import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage, withFormik } from "formik";
import { Effect } from "formik-effect";
import Component from "@reach/component-component";
import Heading from "../heading/Heading";
import * as yup from "yup";
import axios from "axios";
import * as UTIL from '../../util'; // Form Debugger
// import { Debug } from "./Debug";

import { Row, Col, Button } from "react-bootstrap"; // Global Element

import { FormInput, FormCheckbox, Requirements, FormSelect } from "./elements";
import Modal from "../modal/Modal";
import { Modal as BootstrapModal } from "react-bootstrap"; // Validation schema

import { validation } from "./util/validation";
var routeURL = "".concat(UTIL.apiUtil.API.emailMeals);

function Parent(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow() {
    return setShow(true);
  };

  var handleRedirect = function handleRedirect() {
    window.location = "/";
  };

  return /*#__PURE__*/React.createElement("div", null, children(show, handleShow, handleClose, handleRedirect));
}

var formikEnhancer = withFormik({
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      firstName: props.firstName,
      lastName: props.lastName,
      emailAddress: props.emailAddress,
      phoneNumber: props.phoneNumber,
      zipCode: props.zipCode,
      state: props.state,
      city: props.city,
      eventDate: props.eventDate,
      eventGroupSize: props.eventGroupSize,
      emailSendTo: props.emailSendTo
    };
  },
  validationSchema: yup.object().shape({
    firstName: validation.notEmpty,
    lastName: validation.notEmpty,
    emailAddress: validation.emailAddress,
    phoneNumber: validation.phoneNumber,
    zipCode: validation.zipCode,
    state: validation.notEmpty,
    city: validation.notEmpty,
    eventDate: validation.notEmpty,
    eventGroupSize: validation.notEmpty
  }),
  handleSubmit: function handleSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting;
    setTimeout(function () {
      JSON.stringify(values, null, 2);
      setSubmitting(false);
    }, 1000);
    axios({
      method: "post",
      url: routeURL,
      data: values
    }).then(function (response) {
      //handle success
      console.log(response);
    }).catch(function (response) {
      //handle error
      console.log(response);
    });
  },
  displayName: "Meals and Gifts" // helps with React DevTools

});
var eventGroupOptions = [{
  label: "Event Group Size",
  value: ""
}, {
  label: "0-24",
  value: "0-24"
}, {
  label: "25-50",
  value: "25-50"
}, {
  label: "50-100",
  value: "50-100"
}, {
  label: "100+",
  value: "100+"
}];

var MealsandGifts = function MealsandGifts(props) {
  var values = props.values,
      _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      setFieldValue = props.setFieldValue,
      handleSubmit = props.handleSubmit,
      _props$emailSendTo = props.emailSendTo,
      emailSendTo = _props$emailSendTo === void 0 ? "emailSendTo" : _props$emailSendTo,
      _props$contactInfo = props.contactInfo,
      contactInfo = _props$contactInfo === void 0 ? "Contact Information" : _props$contactInfo,
      _props$eventInfo = props.eventInfo,
      eventInfo = _props$eventInfo === void 0 ? "Details about your event" : _props$eventInfo;
  var ExperienceValidation = errors.firstName || errors.lastName || errors.userZipCode || errors.emailAddress || errors.phoneNumber;
  useEffect(function () {
    if (!props.model) {
      setFieldValue(emailSendTo, "catering@crackerbarrel.com");
    } else {
      setFieldValue(emailSendTo, props.model.emailSendTo);
    }
  }, []);
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, {
    className: "d-none"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    value: emailSendTo,
    name: "emailSendTo",
    label: "emailSendTo",
    component: FormInput,
    className: "cb-form__input--full"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: contactInfo
    },
    className: "cb-type__title"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "firstName",
    label: "Your Name",
    component: FormInput
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "lastName",
    label: "Company Name",
    component: FormInput
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "email",
    name: "emailAddress",
    label: "Email Address",
    component: FormInput
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "tel",
    name: "phoneNumber",
    label: "Phone Number",
    component: FormInput
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "zipCode",
    label: "Zipcode",
    component: FormInput
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "state",
    label: "State",
    component: FormInput
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "city",
    label: "City",
    component: FormInput
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: eventInfo
    },
    className: "cb-type__title"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    className: "date",
    type: "date",
    name: "eventDate",
    label: "Event Date",
    component: FormInput
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    type: "select",
    name: "eventGroupSize",
    label: "Event Group Size",
    changeHandler: handleChange,
    options: eventGroupOptions,
    component: FormSelect
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Parent, null, function (show, handleShow, handleClose, handleRedirect) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: ExperienceValidation,
      onClick: function onClick(e) {
        return handleShow(true);
      },
      className: "cb-button-primary"
    }, "Submit"), /*#__PURE__*/React.createElement(Modal, {
      show: show,
      hide: handleClose,
      title: "THANK YOU"
    }, /*#__PURE__*/React.createElement(BootstrapModal.Body, {
      classname: "text-center"
    }, /*#__PURE__*/React.createElement("p", null, "Thank you for contacting us about our Celebration Meals and Gifts. One of our Catering Specialists will call or email you to answer any questions and take your order.")), /*#__PURE__*/React.createElement(BootstrapModal.Footer, null, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary",
      onClick: handleRedirect
    }, "Return Home"))));
  }))));
};

export default formikEnhancer(MealsandGifts);